/**
 * Please don't put any additional types into this file.
 * Most things should instead live in a more specifically named file.
 */
import { z } from "zod";

import { SpecialVersionType } from "./enums.js";

export type HexVersionString =
  | (string & { __type: "HexVersionString" })
  | SpecialVersionType;

export const zHexVersionString = z
  .string()
  .transform((val) => val as HexVersionString);

export const JsonSerializedParameterValueContents = z
  .string()
  .brand("JsonSerializedParameterValueContents");
export type JsonSerializedParameterValueContents = z.infer<
  typeof JsonSerializedParameterValueContents
>;

export const zJsonSerializedParameterValueContents = z
  .string()
  .transform((val) => val as JsonSerializedParameterValueContents);

export const ParameterName = z.string().brand("ParameterName");
export type ParameterName = z.infer<typeof ParameterName>;

export const zParameterName = z
  .string()
  .transform((val) => val as ParameterName);

export const SecretName = z.string().brand("SecretName");
export type SecretName = z.infer<typeof SecretName>;

export const zSecretName = z.string().transform((val) => val as SecretName);

export const VariableName = z.union([ParameterName, SecretName]);
export type VariableName = z.infer<typeof VariableName>;

export const KernelImage = z.string().brand("KernelImage");
export type KernelImage = z.infer<typeof KernelImage>;

export const zKernelImage = z.string().transform((val) => val as KernelImage);

export const KernelImageTag = z.string().brand("KernelImageTag");
export type KernelImageTag = z.infer<typeof KernelImageTag>;

export const KernelImageUrl = z.string().brand("KernelImageUrl");
export type KernelImageUrl = z.infer<typeof KernelImageUrl>;

export const KernelIdleTimeout = z.number().brand("KernelIdleTimeout");
export type KernelIdleTimeout = z.infer<typeof KernelIdleTimeout>;

export const GitSyncStateKey = z.string().brand("GitSyncStateKey");
export type GitSyncStateKey = z.infer<typeof GitSyncStateKey>;

export const QueryCacheKey = z.string().brand("QueryCacheKey");
export type QueryCacheKey = z.infer<typeof QueryCacheKey>;
